/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable func-names */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { useTour } from "src/context/global/TourContext";
import REPORT_ERROR_MESSAGE from "src/graphql/mutation/settings/reportingErrorMessage";
import ADD_PAGE from "src/graphql/mutation/settings/addPage";
import GET_PAGES from "src/graphql/query/settings/getPages";
import { useMutation, useLazyQuery } from "@apollo/client";
import NoRecordFound from "src/components/shared/molecules/NoRecordFound";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useSnackbar } from "notistack";
import expressConfig from "src/config/express.json";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { FacebookFunc } from "src/utils/auth/Facebook";
import {
  getFacebookToken,
  getWabaDetails,
  getPhoneNumberDetails,
  subscribeAppToWaba,
  registerPhoneNumber,
  enableCallingOnPhoneNumber,
  getUserData,
  getWhatsAppBusinessProfile,
} from "./whatsappDetailFunc";
import UpperComponent from "./upperComponent";
import LowerComponent from "./lowerComponent";
import RegistrationPinModal from "./VerificationMethodModal";
import useStyle from "./Styles";

type wabadetailsObject = {
  business_verification_status: string;
  id: string;
  name: string;
  status: string;
};

type phoneNumberdetailsObject = {
  code_verification_status: string;
  display_phone_number: string;
  id: string;
  quality_rating: string;
  status: string;
  verified_name: string;
};

type whatsAppBusinessProfile = {
  about?: string;
  address?: string;
  description?: string;
  email?: string;
  messaging_product: "whatsapp";
  profile_picture_url?: string;
  websites?: string[];
  vertical?: string;
};

type userProfile = {
  id: string;
  name: string;
  email: string;
  picture: {
    data: {
      url: string;
    };
  };
};

type accessTokenDataObject = {
  access_token: string;
  token_type: string;
  expires_in: string;
};

interface IPage {
  name: string;
  pageId: string;
  accesstoken: string;
  picture: string;
  mainSuperAdminId: string;
  source: string;
  email: string;
  waba_name: string;
  waba_id: string;
}

const Whatsapp = () => {
  const env = process.env.NODE_ENV || "development";
  const { enqueueSnackbar } = useSnackbar();

  const isBelow400px = useMediaQuery("(max-width:400px)");

  const { classes } = useStyle();
  const [waProcessLoading, setWaProcessLoading] = useState<boolean>(false);
  const [pagesData, setPagesData] = useState<any[]>([]);
  const [reportedErrorMessage, setReportedErrorMessage] = useState<
    string | null
  >(null);
  const [verificationMethod, setVerificationMethod] = useState<"SMS" | "VOICE">(
    "SMS",
  );

  const [showVerifModal, setShowVerifModal] = useState(false);
  const [pendingRegData, setPendingRegData] = useState<any>(null);

  const [facebookUserProfile, setFacebookUserProfile] =
    useState<userProfile | null>(null);

  const [modifiedAddedPages, setModifiedAddedPages] = useState<IPage[]>([]);

  const { startPostFbConnectionTour, guideData } = useTour();
  const modalRef = useRef<any>(null);

  const [signupSession, setSignupSession] = useState<{
    code?: string;
    phone_number_id?: string;
    waba_id?: string;
  }>({});

  const config = expressConfig[env];
  const { mainSuperAdminId } = useActiveUserDetail();
  const [addPages, { data: addPagesMutationResult }] = useMutation(ADD_PAGE);
  const [reportErrorMessage, { data: reportErrorMessageMutationResult }] =
    useMutation(REPORT_ERROR_MESSAGE);

  useEffect(() => {
    if (
      reportErrorMessageMutationResult &&
      reportErrorMessageMutationResult.reportingErrorMessage
    ) {
      const { error, success, result } =
        reportErrorMessageMutationResult.reportingErrorMessage;
      if (error) {
        enqueueSnackbar(addPagesMutationResult.addpages.error, {
          variant: "error",
        });
      } else if (success) {
        enqueueSnackbar(result, {
          variant: "success",
        });
      }
    }
  }, [addPagesMutationResult]);

  const handleLogoutFacebook = () => {
    setFacebookUserProfile(null);
    try {
      if (window.FB) {
        window.FB.logout();
      }
    } catch (err) {
      console.warn("FB logout error", err);
    }
  };

  const [pageExistingError, setPageExistingError] = useState<string | null>(
    null,
  );

  // handle existing pages error
  const handleExistingPagesError = (error: string) => {
    setPageExistingError(error);
  };

  const [errorBoxHeight, setErrorBoxHeight] = useState<number>(0);

  useEffect(() => {
    FacebookFunc.fbInt();

    const sessionInfoListener = async (event: any) => {
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP" && data.event === "FINISH") {
          // if user finishes the Embedded Signup flow

          const { phone_number_id, waba_id } = data.data;
          setSignupSession((prev) => ({
            ...prev,
            phone_number_id,
            waba_id,
          }));
        } else if (
          data.type === "WA_EMBEDDED_SIGNUP" &&
          data.event === "ERROR"
        ) {
          const { error_message } = data.data;
          setReportedErrorMessage(error_message);
          // Implement your internal error reporting mechanism here
          // reportErrorToBackend(error_message);
        }
        //
        else if (
          data.type === "WA_EMBEDDED_SIGNUP" &&
          data.event === "CANCEL"
        ) {
          enqueueSnackbar(
            `Embedded signup cancelled at ${data.data.current_step}`,
            {
              variant: "error",
            },
          );
        }
      } catch {
        // Don’t parse info that’s not a JSON
        console.log("Non JSON Response", event.data);
      }
    };

    window.addEventListener("message", sessionInfoListener);

    return () => {
      window.removeEventListener("message", sessionInfoListener);
    };
  }, []);

  // const updatePagesFunc = useCallback(
  //   (pagesAray: IPage[]) => {
  //     setPagesData((prev: any[]) => {
  //       // Filter new page IDs that are not in the previous state
  //       const newPages = pagesAray.filter(
  //         (item: { pageId: any }) =>
  //           !prev.some((i: any) => i.pageId === item.pageId),
  //       );

  //       // Get removed page IDs for the logged-in user
  //       const removedPageIds = prev
  //         .filter(
  //           (item: { metaId: string; pageId: string }) =>
  //             item.metaId === facebookUserProfile?.id,
  //         )
  //         .filter(
  //           (item: { pageId: string }) =>
  //             !pagesAray.some(
  //               (j: { pageId: string }) => j.pageId === item.pageId,
  //             ),
  //         )
  //         .map((item: { pageId: string }) => item.pageId);

  //       // Update the existing pages with the new `isSelected` status
  //       const updatedPages = prev.map((j: { pageId: any }) => {
  //         if (removedPageIds.includes(j.pageId)) {
  //           return {
  //             ...j,
  //             isSelected: false,
  //           };
  //         }
  //         return j;
  //       });

  //       return [...newPages, ...updatedPages];
  //     });
  //   },
  //   [modifiedAddedPages],
  // );

  const updatePagesFunc = useCallback((pagesArray: IPage[]) => {
    setPagesData((prev) => {
      const newPages = pagesArray.filter(
        (item) => !prev.some((p) => p.pageId === item.pageId),
      );

      // return [...prev, ...newPages];
      return [...newPages, ...prev];
    });
  }, []);

  useEffect(() => {
    if (addPagesMutationResult && addPagesMutationResult.addpages) {
      const { success, error, result } = addPagesMutationResult.addpages;
      let successfullyAddedCount = 0;

      if (success === 0 && error) {
        enqueueSnackbar(error, {
          variant: "error",
        });
        handleExistingPagesError(error);

        let filteredPages = modifiedAddedPages;
        if (result) {
          try {
            const erroredIds = JSON.parse(result);
            if (Array.isArray(erroredIds)) {
              filteredPages = modifiedAddedPages.filter(
                (pageObj) => !erroredIds.includes(pageObj.pageId),
              );
            }
          } catch (e) {
            // Fallback to name-based filtering
            const erroredPages = error
              .split("has")[0]
              .split(",")
              .map((page: string) => page.trim());

            filteredPages = modifiedAddedPages.filter(
              (pageObj) => !erroredPages.includes(pageObj.name),
            );
          }
        }

        updatePagesFunc(filteredPages);
        successfullyAddedCount = filteredPages.length;
      } else if (success) {
        enqueueSnackbar("WA Number(s) has been added", {
          variant: "success",
        });
        updatePagesFunc(modifiedAddedPages);
        successfullyAddedCount = modifiedAddedPages.length;
      }

      // Start tour if we actually connected at least one page
      if (
        successfullyAddedCount > 0 &&
        !guideData?.getUserGuide?.postFbConnectionCompleted
      ) {
        setTimeout(() => {
          startPostFbConnectionTour();
        }, 1000);
      }
      setWaProcessLoading(false);
    }
  }, [addPagesMutationResult, guideData]);

  const checkingValidityOfAccessToken = async (token: any) => {
    try {
      const data = await axios.get(
        `https://graph.facebook.com/v19.0/debug_token`,
        {
          params: {
            input_token: token,
            access_token: `${config.facebook_app_id}|${config.FACEBOOK_APP_SECRET}`,
          },
        },
      );
      return data.data;
    } catch (error) {
      enqueueSnackbar("Something went wrong.", {
        variant: "error",
      });
    }
  };

  const getLoginStatus = async () => {
    if (window.FB) {
      window.FB.getLoginStatus(async function (response: any) {
        if (response.status === "connected") {
          const { accessToken } = response.authResponse;

          // its for checking the validity of the token in order to prevent malicious token
          if (accessToken) await checkingValidityOfAccessToken(accessToken);

          const userProfile: userProfile = await getUserData(accessToken);
          setFacebookUserProfile(userProfile);
        } else if (response.status === "not_authorized") {
          enqueueSnackbar("Embedded signup flow authentication error", {
            variant: "error",
          });
        } else {
          enqueueSnackbar("Embedded signup flow authentication error", {
            variant: "error",
          });
        }
      }, true);
    }
  };
  const launchWhatsAppSignup = async () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      // (await window.fbq) &&
      //   window.fbq("trackCustom", "WhatsAppOnboardingStart", {
      //     appId: config.facebook_app_id,
      //     feature: "whatsapp_embedded_signup",
      //   });

      // Define an async function for the response handling
      const handleFBResponse = async (response: any) => {
        if (response.authResponse) {
          const { code } = response.authResponse;
          if (code) {
            setSignupSession((prev) => ({
              ...prev,
              code,
            }));
          }
          // if there is no data for the logged-in user, get it
          if (!facebookUserProfile) await getLoginStatus();
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      };

      // Launch Facebook login with a regular function that calls the async handler
      window.FB.login(
        function (response: any) {
          handleFBResponse(response).catch((e) => {
            console.error("Error handling FB response", e);
          });
        },
        {
          config_id: config.WHATSAPP_CONFIG_ID,
          response_type: "code", // must be set to 'code' for System User access token
          override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
          extras: {
            // feature: "whatsapp_embedded_signup",
            // sessionInfoVersion: 2, //  Receive Session Logging Info
            feature: "whatsapp_embedded_signup",
            sessionInfoVersion: 3, //  Receive Session Logging Info
          },
        },
      );
    } catch (e) {
      enqueueSnackbar("Something went wrong.", {
        variant: "error",
      });
    }
  };

  const [
    getPages,
    { loading: getPagesQueryLoading, data: getPagesQueryResult },
  ] = useLazyQuery(GET_PAGES, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    getPages({
      variables: {
        mainSuperAdminId,
        source: "whatsapp",
        onlySelected: false,
      },
    });
  }, [mainSuperAdminId]);

  useEffect(() => {
    const pages: any = [];
    if (getPagesQueryResult?.getAllPages?.result?.length) {
      getPagesQueryResult.getAllPages.result.forEach(
        (curr: any, index: number) =>
          pages.push({
            order: index,
            ...curr,
          }),
      );
      setPagesData(pages);
    } else if (getPagesQueryResult?.getAllPages?.success === 0) {
      enqueueSnackbar(getPagesQueryResult.getAllPages.error, {
        variant: "error",
      });
      setPagesData([]);
    } else {
      setPagesData([]);
    }
  }, [getPagesQueryResult]);

  useEffect(() => {
    if (facebookUserProfile && reportedErrorMessage) {
      const errorReportingRecord = {
        erorrMsg: reportedErrorMessage,
        email: facebookUserProfile.email,
        metaId: facebookUserProfile.id,
        name: facebookUserProfile.name,
        picture: facebookUserProfile.picture.data.url,
      };

      reportErrorMessage({
        variables: {
          input: [errorReportingRecord],
        },
      });
      setReportedErrorMessage(null);
    }
  }, [reportedErrorMessage, facebookUserProfile]);

  useEffect(() => {
    const { code, phone_number_id, waba_id } = signupSession;
    if (code && phone_number_id && waba_id && facebookUserProfile) {
      (async () => {
        try {
          setWaProcessLoading(true);
          const accessTokenData: accessTokenDataObject =
            await getFacebookToken(code);
          const { access_token } = accessTokenData;

          const wabadetails: wabadetailsObject = await getWabaDetails(
            waba_id,
            access_token,
          );

          const phoneNumberdetails: phoneNumberdetailsObject =
            await getPhoneNumberDetails(phone_number_id, access_token);

          const phoneNumberProfileData = await getWhatsAppBusinessProfile(
            phone_number_id,
            access_token,
          );

          const phoneProfile: whatsAppBusinessProfile =
            phoneNumberProfileData.data[0];

          const isAlreadyRegisteredAndActive =
            phoneNumberdetails.code_verification_status === "VERIFIED" &&
            phoneNumberdetails.status === "CONNECTED";

          if (!isAlreadyRegisteredAndActive) {
            const normalizedPhone =
              phoneNumberdetails.display_phone_number.replace(/\D/g, "");

            if (!normalizedPhone.startsWith("1555")) {
              await subscribeAppToWaba(waba_id, access_token);

              // Instead of automatic registration, we show the modal to pick method
              setPendingRegData({
                phone_number_id,
                access_token,
                waba_id,
                waba_name: wabadetails.name,
                display_phone_number: phoneNumberdetails.display_phone_number,
                verified_name: phoneNumberdetails.verified_name,
                picture: phoneProfile.profile_picture_url || "",
              });
              setShowVerifModal(true);
              setWaProcessLoading(false); // Stop loading while user picks
              return; // Exit early, confirmation handler will finish this
            }
            console.log(
              "Its a display-name for testing purpose/meta generated phone number",
            );
          } else {
            console.log(
              "Phone number is already registered and active. Skipping registration.",
            );
          }

          const waNewPhoneNumberRecord = {
            waba_id,
            waba_name: wabadetails.name,
            wa_number: phoneNumberdetails.display_phone_number,
            name: phoneNumberdetails.verified_name,
            pageId: phone_number_id,
            accesstoken: access_token,
            picture: phoneProfile.profile_picture_url || "",
            mainSuperAdminId: mainSuperAdminId.toString(),
            source: "whatsapp",
            email: facebookUserProfile.email,
            metaId: facebookUserProfile.id,
          };

          addPages({
            variables: {
              input: [waNewPhoneNumberRecord],
            },
            refetchQueries: [
              {
                query: GET_PAGES,
                variables: {
                  mainSuperAdminId,
                  source: "whatsapp",
                  onlySelected: false,
                },
              },
            ],
          });

          // update local state
          setModifiedAddedPages([waNewPhoneNumberRecord]);
          //  clear signup session after successful addition
          setSignupSession({});
        } catch (err: any) {
          console.error("whatsapp sign up flow error\n", err);
          enqueueSnackbar(err.message, {
            variant: "error",
          });
          setWaProcessLoading(false);
        }
      })();
    }
  }, [signupSession, facebookUserProfile]);

  const handleVerifConfirm = async (pin: string) => {
    if (!pendingRegData) return;

    try {
      setWaProcessLoading(true);
      const {
        phone_number_id,
        access_token,
        waba_id,
        waba_name,
        display_phone_number,
        verified_name,
        picture,
      } = pendingRegData;

      await registerPhoneNumber(phone_number_id, access_token, pin);

      // Turn on WhatsApp Calling for the number. Non-fatal: if this
      // fails (usually because the number's messaging tier is under
      // 2000/day, which Meta requires), the number is still fully
      // set up for messaging and admins can flip the toggle later.
      try {
        await enableCallingOnPhoneNumber(phone_number_id, access_token);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(
          "Could not auto-enable calling on WhatsApp phone number",
          err,
        );
      }

      const waNewPhoneNumberRecord = {
        waba_id,
        waba_name,
        wa_number: display_phone_number,
        name: verified_name,
        pageId: phone_number_id,
        accesstoken: access_token,
        picture,
        mainSuperAdminId: mainSuperAdminId.toString(),
        source: "whatsapp",
        email: facebookUserProfile?.email || "",
        metaId: facebookUserProfile?.id || "",
      };

      await addPages({
        variables: {
          input: [waNewPhoneNumberRecord],
        },
        refetchQueries: [
          {
            query: GET_PAGES,
            variables: {
              mainSuperAdminId,
              source: "whatsapp",
              onlySelected: false,
            },
          },
        ],
      });

      setModifiedAddedPages([waNewPhoneNumberRecord]);
      setPendingRegData(null);
      setWaProcessLoading(false);
    } catch (err: any) {
      console.error("Registration confirmation error:", err);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
      setWaProcessLoading(false);
    }
  };

  const containerRef = useRef<HTMLDivElement>(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleScroll = () => {
    if (containerRef.current) {
      const currentScroll = containerRef.current.scrollTop;
      // Hysteresis: Collapse at 60px, only Expand back at < 10px for maximum stability
      if (currentScroll > 60) {
        setIsCollapsed(true);
      } else if (currentScroll < 10) {
        setIsCollapsed(false);
      }
    }
  };

  return (
    <Box className={classes.rootBox} ref={containerRef} onScroll={handleScroll}>
      <Box className={classes.decorationBlob} />

      {getPagesQueryLoading ? (
        <Box className={classes.loadingCircularProgressBox}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            // Guaranteed scroll room to prevent layout-driven scroll resets
            minHeight: "calc(100% + 200px)",
          }}
        >
          <Box className={classes.stickyHeader}>
            <UpperComponent
              modalRef={modalRef}
              handleClick={launchWhatsAppSignup}
              facebookUserProfile={facebookUserProfile}
              waProcessLoading={waProcessLoading}
              logout={handleLogoutFacebook}
              pageExistingError={pageExistingError}
              handleClickError={() => handleExistingPagesError("")}
              setErrorBoxHeight={setErrorBoxHeight}
              isCollapsed={isCollapsed}
            />
          </Box>

          {!getPagesQueryLoading && pagesData.length > 0 && (
            <Box
              sx={{
                // mt: isCollapsed ? 26 : 3,
                mt: isCollapsed ? "100px" : "20px",
                transition: "margin-top 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <LowerComponent
                pagesData={pagesData}
                setPagesData={setPagesData}
              />
            </Box>
          )}

          {!getPagesQueryLoading && pagesData.length === 0 && (
            <Box mt={10} display="flex" justifyContent="center">
              <NoRecordFound />
            </Box>
          )}
        </Box>
      )}

      <RegistrationPinModal
        open={showVerifModal}
        onClose={() => {
          setShowVerifModal(false);
          setPendingRegData(null);
        }}
        onConfirm={handleVerifConfirm}
      />
    </Box>
  );
};

export default Whatsapp;
